(() => {
  const dangerousSymbols = /[<>'";()]/g;
  const currentUrl = window.location.href;
  const urlObj = new URL(currentUrl);
  const urlParams = new URLSearchParams(urlObj.search);
  const searchTerms = urlParams.get('q');

  if (dangerousSymbols.test(searchTerms)) {
    const safeSearchTerms = searchTerms.replace(dangerousSymbols, '');
    urlParams.set('q', safeSearchTerms)
    urlObj.search = urlParams.toString();
    window.location.href = urlObj.toString();
  }
})();